import { Button } from '@chakra-ui/react';
import styled, { css } from 'styled-components';

type BoxType = {
  isOpen?: boolean;
  isDisabled?: boolean;
  withHigherIndex?: boolean;
};

export const DeleteButton = styled(Button)`
  position: absolute !important;
  bottom: -20px;
  right: -58px;
  z-index: 2;
  background: #fdfdfd !important;
  border: 1px solid #ebebeb;
  svg {
    fill: #ef5b5b;
    width: 14px;
  }
  color: #ef5b5b;
`;

const disabledFilter = css`
  & * {
    color: ${(props) => props.theme.colors['neutral-80']} !important;
  }
`;

export const Box = styled.div<BoxType>`
  position: relative;
  cursor: pointer;
  height: 36px;
  border-radius: 20px;
  padding: 5px 12px;
  display: inline-flex;
  z-index: ${(props) => (props.withHigherIndex ? '1' : 'initial')};
  filter: ${(props) =>
    !props.isOpen ? 'initial' : 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.07))'};
  background-color: ${(props) =>
    props.isOpen ? props.theme.colors['secondary-20'] : props.theme.colors['neutral-20']};
  border: 1px solid;
  border-color: ${(props) =>
    props.isOpen ? props.theme.colors['neutral-30'] : props.theme.colors['neutral-40']};
  margin-bottom: 8px;
  align-items: center;
  &:not(&:last-of-type) {
    margin-right: 10px;
  }
  ${({ isDisabled }) => isDisabled && disabledFilter}
  &:hover {
    background: ${(props) =>
      props.isOpen ? props.theme.colors['secondary-20'] : props.theme.colors['neutral-30']};
  }
`;
